<template>
  <div class="main">
    <div class="content">
      <img src="../../assets/img/finish.png" alt="" />
      <p style="font-size: 24px;margin: 30px 0;">您已完成机构注册</p>
      <div>
        <el-button
          style="width: 120px"
          type="primary"
          size=""
          autofocus
          @click="join()"
          >立即体验</el-button
        >
        <el-button
          style="margin-left: 20px; width: 120px"
          size=""
          @click="out()"
          >退出登录</el-button
        >
      </div>
      <div class="info">
        <p>{{ orgName }}</p>
        <div>
          <span class="info_tip"
            >该机构在教育部校外培训监管机构平台备案状态：</span
          >
          <span class="info_status" :style="{ color: activeColor}"  > {{ statusName }} </span>
          <span v-if="status != '3'"
            ><span class="info_tip"> 请尽快完成备案！</span>
            <span class="goba" @click="record">去备案 ></span></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateIdcard } from "@/utils/validate.js";
import { handleRegister } from "@/api/register/index.js";
export default {
  props: {},
  data() {
    return {
      orgName: "暂无机构信息",
      status: "1",
      activeColor: '',
    };
  },
  computed: {
    statusName() {
      let name = "";
      if (this.status === "4") {
        name = "已注销";
        this.activeColor='red'
      } else if (this.status === "2") {
        name = "审核中";
        this.activeColor='red'
      } else if (this.status === "3") {
        name = "已备案";
        this.activeColor='#4991e1'
      } else {
        name = "机构不存在";
        this.activeColor='#000'
      }
      return name;
    },
  },
  watch: {},
  mounted() {},
  created() {
    if (sessionStorage.getItem("mechanismInfo")) {
      this.status =
        JSON.parse(sessionStorage.getItem("mechanismInfo")).status || "无信息";
    }
    if (sessionStorage.getItem("orgName")) {
      this.orgName = sessionStorage.getItem("orgName") || "暂无机构信息";
    }
  },
  methods: {
    // 新用户需要设置密码再登录，游客绑定完机构后直接登录
     join() {
        window.location.href = `https://assfe.tianyuyun.com/?usessionId=${sessionStorage.getItem(
          "usessionId"
        )}`;
      // if (
      //   sessionStorage.getItem("userType") &&
      //   sessionStorage.getItem("userType") == "tourist"
      // ) {
      //   window.location.href = `http://assfe.t.huijiaoyun.com/?usessionId=${sessionStorage.getItem(
      //     "usessionId"
      //   )}`;
      // }else{
      //    this.$emit("changeStep", 4);
      // }
    },
    record() {

      //  window.location.href ='https://xwpx.eduyun.cn/bmp-web/' 
       window.open('https://xwpx.eduyun.cn/bmp-web/' )
    },
    out() {
      var domain = sessionStorage.getItem("domain");
       window.open(
          `${domain}/index.php?r=portal/user/logout&service=${domain}`,
          "_self"
        );
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 4%;
  .content {
    margin-top: 30px;
    width: 650px;
    text-align: center;
    img {
      height: 66px;
      width: 66px;
    }
    p {
      font-family: PingFang SC;
      font-weight: 400;
    }
    .info {
      width: 647px;
      height: 80px;
      margin-top: 80px;
      background: #f4f9ff;
      font-size: 14px;
      padding: 10px;
      p {
        margin-top: 5px;
      }
      div {
        margin-top: 10px;
      }
      .info_tip {
        margin-left: 5px;
        color: #a3a4a5;
      }
      .info_status {
        font-style: 16px;
      }
      .goba {
        color: #4991e1;
        cursor: pointer;
      }
    }
  }
}
</style>
